import createAxe from '../../middlewares/Axe';
import { goLoading, outLoading } from '../loadingActions';
import { getDirectionFromList } from '../viewActions';
import { triggerError, digestErrorCode } from '../maintenanceActions';
import { Loading as i18n, Errors as i18nErrors } from '../../middlewares/i18n';
import * as types from './actionTypes';

export function setConsents(consents) {
  return {
    type: types.SET_CONSENTS,
    consents
  };
}

// Main function to submit consent opt-ins using new batch API
export function submitConsents(consentData) {
  return async function(dispatch, getState) {
    const lang = getState().i18n.language.current;
    const clientId = getState().client.client_id;
    
    // Get next direction from the directions list
    const nextDir = dispatch(getDirectionFromList());

    dispatch(goLoading(i18n[lang].processing));

    try {
      const axe = createAxe(getState());
      
      // Convert consent data to the new batch format
      const consents = {};
      consentData.forEach(consent => {
        consents[consent.type] = consent.value;
      });
      
      // Use new batch PATCH endpoint
      const res = await axe('/3971cc86b21c6924/v2/consents/machine', {
        method: 'PATCH',
        headers: {
          'Customer-Token': `Bearer ${clientId}`,
          'Atm-Token': `Bearer ${getState().machine.atm_id}`
        },
        data: {
          consents
        }
      });

      if (res.status === 200) {
        // All consents submitted successfully
        // Navigate to next direction after a short delay
        setTimeout(() => {
          dispatch(outLoading(nextDir));
        }, 500);
      } else {
        // Invalid response status
        setTimeout(() => {
          dispatch(outLoading());
          return dispatch(triggerError(i18nErrors[lang].tryAgain));
        }, 2000);
      }
    } catch (error) {
      return dispatch(digestErrorCode(error.response.status, () => {
        setTimeout(() => {
          dispatch(outLoading());
          return dispatch(triggerError(i18nErrors[lang].tryAgain));
        }, 2000);
      }));
    }
  };
}